import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { IDataStore } from '@/services/dataStore/IDataStore'
import useDataStore from '@/services/dataStore/useDataStore'
import { CostSchema, ICost } from '@lifk/types'
import useSWRV from 'swrv'
import { z } from 'zod'

const useGetCosts = (includeDeprecated = false) => {
  const {
    dataStoreSWRVKey,
    dataStore,
    handleDataStoreError,
    disableValidations
  } = useDataStore()

  async function fetchCosts(dataStore: IDataStore): Promise<ICost[]> {
    try {
      const response = await dataStore.getCosts()

      const validation = z.array(CostSchema).safeParse(response)
      let costs: ICost[] = validation.data ?? []
      if (!validation.success) {
        costs = removeInvalidItems(
          response,
          validation.error,
          disableValidations.value
        )
      }

      return costs.filter((cost) => includeDeprecated || !cost.deprecated)
    } catch (e) {
      handleDataStoreError(e)
      return []
    }
  }

  const result = useSWRV(
    () =>
      `/costs/${dataStoreSWRVKey.value.perspective}?deprecated=${includeDeprecated}`,
    async () => {
      return await fetchCosts(dataStore.value)
    },
    {
      // 30s for adapters to prevent too many API calls to paid CMS's
      dedupingInterval: 30000
    }
  )
  return result
}

export { useGetCosts }
